import { useSelector } from 'react-redux';
import { SummaryStat } from '../../reusableUI/summary/SummaryStat';
import { ProjectedProfitStat } from '../../reusableUI/summary/ProjectedProfitStat';
import { solesAmount } from '../../../helpers/summaryFormatting';

const share = value => value != null && Number.isFinite(Number(value))
    ? `${new Intl.NumberFormat('es-PE',{maximumFractionDigits:1}).format(Number(value))} % de la venta neta` : 'Porcentaje no disponible';

export const ProjectListIndicators = ({ mode = 'profit' }) => {
    const totals = useSelector(state => state.ppto.totales) || {};
    const { access = {} } = useSelector(state => state.auth);
    const projected = {
        profit:totals.soles_total_final_uf,
        margin:totals.soles_margen_final_uf,
        target_margin:access.a20 ? totals.soles_margen_presupuestado : null,
    };
    return <div className="p-summary-stats" role="region" aria-label="Indicadores de proyectos">
        <SummaryStat label="Total venta" value={solesAmount(totals.soles_total_final_venta)}
            context={`${totals.cantidad ?? '—'} proyectos · monto neto aprobado`}
            description="Ventas netas de todos los proyectos que cumplen los filtros, no solo los de esta página. Importes consolidados en soles." />
        {mode === 'cash' ? <>
            <SummaryStat label="Cobrado" value={solesAmount(totals.flujo_total_cobrado)} context={share(totals.flujo_margen_cobrado)} />
            <SummaryStat label="Pagado" value={solesAmount(totals.flujo_total_pagado)} context={share(totals.flujo_margen_pagado)} />
            <SummaryStat label="Saldo en caja" value={solesAmount(totals.flujo_saldo)} context={share(totals.flujo_margen_saldo)} />
        </> : access.a22 && <>
            <SummaryStat label="Gasto real" value={solesAmount(totals.soles_total_final_gr)} context={share(totals.soles_margen_final_gr)}
                description="Costos netos ejecutados, registrados en órdenes de servicio o compras de los proyectos filtrados." />
            <SummaryStat label="Rentabilidad real" value={solesAmount(totals.soles_total_final_ur)} context={share(totals.soles_margen_final_ur)}
                description="Venta neta menos gastos reales netos registrados hasta hoy. Aún no descuenta los costos pendientes de ejecutar." />
        </>}
        {mode === 'profit' && access.a22 && access.a23 && <ProjectedProfitStat projects={projected} currency={{simbolo:'S/'}} href={null} scopeLabel="Proyectos filtrados" />}
    </div>;
};
